// extracted by mini-css-extract-plugin
export var cancelButton = "_ox-5";
export var content = "_ox-3";
export var createButton = "_ox-6";
export var drawerContainer = "_ox-0";
export var footer = "_ox-2";
export var header = "_ox-1";
export var orderFormColumn = "_ox-4";